import { cn } from '../../../../utils/styles';
import { InputClassNames } from '../../constants';

import { InputLabelRoot, InputLabelText } from './InputLabel.styled';

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  hasError: boolean | undefined;
  label: string | undefined;
  tooltipLabel: JSX.Element | undefined;
  isLabelHidden: boolean | undefined;
  isDisabled: boolean | undefined;
};

const InputLabel: React.FC<Props> = props => {
  const {
    className,
    isLabelHidden,
    label,
    tooltipLabel,
    hasError = false,
    isDisabled = false,
    ...rest
  } = props;

  const isLabelDefined = !!label || !!tooltipLabel;

  if (isLabelHidden || !isLabelDefined) return null;

  return (
    <InputLabelRoot
      $hasError={hasError}
      $isDisabled={isDisabled}
      className={cn(InputClassNames.Label, className)}
      {...rest}>
      <InputLabelText>{label}</InputLabelText>
      {tooltipLabel && tooltipLabel}
    </InputLabelRoot>
  );
};

export default InputLabel;
